import ListSpecification from '../ListSpecifications';
import './SectionSpecifications.scss';

function SectionSpecifications(props) {
return (
    <div className='section-specifications'>
        <div className='wrapper'>
            <div className='section-specifications_line'>
                <div>
                    <p>Основные особенности</p>
                    <ListSpecification list = {props.card.listSpecifications[0]} />

                </div>
                <div>
                    <p>Видеосекция</p>
                    <ListSpecification list = {props.card.listSpecifications[1]} />

                </div>
            </div>
            <div className='section-specifications_line'>
                <div>
                    <p>Аудиосекция</p>
                    <ListSpecification list = {props.card.listSpecifications[2]} />

                </div>
                {
                    props.card.id === "UBR-X100" ? (
                        <div>
                            <p>Разъемы</p>
                            <ListSpecification list = {props.card.listSpecifications[3]} />
                        </div>
                    ): ""}
            </div>
            <div className='section-specifications_line'>
                {
                    props.card.id === "UBR-X100" ? (
                        <>
                          <div>
                            <p>Технические характеристики</p>
                            <ListSpecification list = {props.card.listSpecifications[4]} />
    
                        </div>
                        <div>
                            <p>Общие характеристики</p>
                            <ListSpecification list = {props.card.listSpecifications[5]} />
                        </div>
                        </>
                    ): (
                        <>
                        <div>
                          <p>Коммутация</p>
                          <ListSpecification list = {props.card.listSpecifications[3]} />
  
                      </div>
                      <div>
                          <p>Технические характеристики</p>
                          <ListSpecification list = {props.card.listSpecifications[4]} />
                      </div>
                      </>
                    )}
            </div>
                {
                    props.card.id === "UBR-X200" ? (
                        <div className='section-specifications_line'>
                            <div>
                                <p>Общие характеристики</p>
                                <ListSpecification list = {props.card.listSpecifications[5]} />
    
                            </div>
                            </div>
                    ): ""}
        </div>
    </div>
)}
export default SectionSpecifications;